const pageName = 'Obvestila';

export default pageName;


